"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IqlQueryOperator;
(function (IqlQueryOperator) {
  IqlQueryOperator["AND"] = "AND";
  IqlQueryOperator["OR"] = "OR";
})(IqlQueryOperator = exports.IqlQueryOperator || (exports.IqlQueryOperator = {}));
var IqlSortOperator;
(function (IqlSortOperator) {
  IqlSortOperator["ASC"] = "ASC";
  IqlSortOperator["DESC"] = "DESC";
})(IqlSortOperator = exports.IqlSortOperator || (exports.IqlSortOperator = {}));
var RangeReferencePoint;
(function (RangeReferencePoint) {
  RangeReferencePoint["DATE_NOW"] = "NOW()";
  RangeReferencePoint["DATE_TODAY_START"] = "DAY().start";
  RangeReferencePoint["DATE_WEEK_START"] = "WEEK().start";
  RangeReferencePoint["DATE_MONTH_START"] = "MONTH().start";
  RangeReferencePoint["DATE_YEAR_START"] = "YEAR().start"; // "last year" = DATE_YEAR_START - 365d (referring to 2019 when it is 2020). Otherwise use "last 365d" = DATE_NOW - 365d
  // TIME_HOUR_START = '...'
  // TEMP_CELSIUS_ZERO = '...'
  // SPEED_SOUND = '...'
  // SPEED_LIGHT = '...'
})(RangeReferencePoint = exports.RangeReferencePoint || (exports.RangeReferencePoint = {}));
var RangeReferenceUnit;
(function (RangeReferenceUnit) {
  RangeReferenceUnit["HOURS"] = "h";
  RangeReferenceUnit["DAYS"] = "d";
  RangeReferenceUnit["WEEKS"] = "w";
  RangeReferenceUnit["MONTHS"] = "m";
  RangeReferenceUnit["YEARS"] = "y";
})(RangeReferenceUnit = exports.RangeReferenceUnit || (exports.RangeReferenceUnit = {}));
// Characters for QueryString composition - got to match with our Grammar!
exports.compoundBegin = '(';
exports.compoundEnd = ')';
exports.leafBegin = '(';
exports.leafEnd = ')';
exports.filterControl = ':';
exports.filterNegate = '~';
exports.valueSeparator = ',';
exports.quoteMark = '"';
exports.HRfilterNegate = 'NOT ';
exports.HRfilterID = 'AS ';
exports.HRfilterSort = ' ORDER BY';
exports.HRvalueSeparator = ', ';